export const Links = {
  LOGIN: "login",
  DASHBOARD: "dashboard",
  SERVICE_DASHBOARD: "service-dashboard",
  HOURS: "hours",
  TIME_SPENT_BY_SERVICE_TICKETS: "service-tickets-hours",
  REPORTS: "reports",
  VIEW_REPORT: "view-report",
  MAINTENANCE_REPORT: "/maintenance-report",
  ALL_SERVICE_TICKETS: "all-service-tickets",
  SERVICE_TICKETS: "service-tickets",
  ASSIGN_TECHNICIAN_SERVICE_TICKETS: "assign-technician-service-tickets",
  ACTION_REQUIRED_SERVICE_TICKETS: "action-required-service-tickets",
  PENDING_SERVICE_TICKETS: "pending-service-tickets",
  PERIODIC_SERVICE_TICKETS: "periodic-service-tickets",
  ONE_TIME_SERVICE_TICKETS: "one-time-service-tickets",
  SERVICE_TICKET: "service-ticket",
  CREATE_SERVICE_TICKET: "service-tickets/create",
  UPDATE_SERVICE_TICKET: "service-tickets/edit",
  ASSETS: "machines",
  SCHEDULING: "scheduling",
  INVENTORY: "inventory",
  ADD_SPARE_PART: "spare-part/add",
  EDIT_SPARE_PART: "spare-part/edit",
  PLANT_OVERVIEW: "plantoverview",
  BREAKDOWN: "breakdown",
  ADD_MACHINE: "machine/add",
  EDIT_MACHINE: "machine/edit",
  MACHINE_SERVICE_TICKET: "machine/service-ticket",
  // INSPECTION: "inspection",
  TEMPLATES: "templates",
  CREATE_TEMPLATE: "template/create",
  EDIT_TEMPLATE: "template/edit",
  USER: "users",
  VENDORS: "vendors",
  ADD_VENDOR: "vendor/add",
  EDIT_VENDOR: "vendor/edit",
  ADD_USER: "user/add",
  EDIT_USER: "user/edit",
  LOCATIONS: "locations",
  ADD_LOCATION: "location/add",
  EDIT_LOCATION: "location/edit",
  MACHINE_MODELS: "machine-models",
  MACHINE_MODEL: "machine-model",
  EDIT_MACHINE_MODELS: "machine-models",
  CREATE_MACHINE_MODELS: "machine-models/create",
  SETTINGS: "settings",
  SPARES_REQUIRED: "spares-required",
  SPARES_RECOMMENDED: "spares-recommended",
  ASSIGNED: "assigned",
  SUBMIT_TICKET_FORM: "submit-ticket-form",
  TEMPLATE_FORM: "template-form",
  EQUIPMENT_SUPPORT_FORM: "equipment-support-form",
};
